import type { GraphQLFormattedError } from 'graphql';

export const graphQLErrorCodeChecker =
  (graphQLErrors: readonly GraphQLFormattedError[] | undefined) => (code: string) =>
    graphQLErrors?.some((e) => e.extensions?.code === code) ?? false;
